export const featuredSliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    className: "slick-arrow-1",
    nextArrow: <button className="slick-next"><i className="fas fa-angle-right"></i></button>,
    prevArrow: <button className="slick-prev"><i className="fas fa-angle-left"></i></button>,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                arrows: false,
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 992,
            settings: {
                arrows: false,
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};

export const getFeaturedSliderSettings = (productCount) => {
    return {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: productCount >= 4 ? 4 : productCount,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        className: "slick-arrow-1",
        nextArrow: <button className="slick-next"><i className="fas fa-angle-right"></i></button>,
        prevArrow: <button className="slick-prev"><i className="fas fa-angle-left"></i></button>,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: productCount >= 3 ? 3 : productCount,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: productCount >= 2 ? 2 : productCount,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
};

export const featuredProjectsSliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    className: "slick-arrow-1",
    nextArrow: <button className="slick-next"><i className="fas fa-angle-right"></i></button>,
    prevArrow: <button className="slick-prev"><i className="fas fa-angle-left"></i></button>,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                arrows: false,
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 992,
            settings: {
                arrows: false,
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};

export const productImageSliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
};

export const bannerSliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    className: "slick-slide-arrow-1 slick-slide-arrow-banner slick-slide-dots-1",
    nextArrow: <button className="slick-next"><i className="fas fa-angle-right"></i></button>,
    prevArrow: <button className="slick-prev"><i className="fas fa-angle-left"></i></button>,
};

export const downloadFileSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <button className="slick-next"><i className="fas fa-angle-right"></i></button>,
    prevArrow: <button className="slick-prev"><i className="fas fa-angle-left"></i></button>,
    responsive: [
        {
            breakpoint: 576, // Para dispositivos móviles
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true, // Opcional: Ocultar flechas en móviles
            }
        }
    ]
};

export const categoriesSliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 2,
    arrows: true,
    autoplay: false,
    swipeToSlide: false,
    swipe: false,
    nextArrow: <button className="slick-next"><i className="fas fa-angle-right"></i></button>,
    prevArrow: <button className="slick-prev"><i className="fas fa-angle-left"></i></button>,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 992,
            settings: {
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                swipeToSlide: true,
                swipe: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                infinite: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                swipeToSlide: true,
                swipe: true
            }
        },
        {
            breakpoint: 576,
            settings: {
                infinite: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                swipeToSlide: true,
                swipe: true
            }
        }
    ]
};